import React, { useRef, } from "react";
import { Map, TileLayer, Marker } from "react-leaflet";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import endPoints from "../../shared/endPoints.json";

export default function UserMap({
  latitude,
  longitude,
  setOpenMap,
  setIsValidAddress,
}) {
  const position = [latitude, longitude];
  const markerRef = useRef(null);

  const submitCoordinates = () => {
    setIsValidAddress(true);
    setOpenMap(false);
  };

  return (
    <form className="Form" style={{ marginTop: "20px" }}>
      <Grid container >
        <Grid item xs={12}>
          <Map
            style={{ height: "80vh" }}
            center={[latitude, longitude]}
            zoom={17}
            scrollWheelZoom={false}
          >
            <Marker position={position} ref={markerRef}></Marker>
            <TileLayer url={endPoints.OSMMAPTILEURL} />
          </Map>
          <Grid
            container
            direction="row"
            justify="space-between"
          >
            <Grid item xs={2}>
              <Button
                style={{ textAlign: "left", marginTop: "16px" }}
                variant="contained"
                color="primary"
                onClick={submitCoordinates}
              >
                επιβεβαιωση
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                style={{ textAlign: "right", marginTop: "16px" }}
                variant="contained"
                color="primary"
                onClick={() => setOpenMap(false)}
              >
                ακυρο
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
